import { normalizeIsin } from "@repo/shared";

type Identity = { name?: string | null; isin?: string | null };

/**
 * QL-174 — when a product's linked instrument is removed, its name and ISIN are
 * cleared only while they still hold exactly what the instrument filled in.
 * A name the designer edited (even only spaces or case) is kept, and so is a
 * value with no auto-filled counterpart to compare against. ISINs are compared
 * in canonical form (trimmed, upper-cased), since that is how they are stored.
 */
export function getIdentityFieldsToClear(
  current: { name: string; isin: string },
  autoFilled: Identity | null | undefined,
): { name: boolean; isin: boolean } {
  const matches = (value: string, filled: string | null | undefined) =>
    typeof filled === "string" && filled !== "" && value === filled;
  return {
    name: matches(current.name, autoFilled?.name),
    isin: matches(normalizeIsin(current.isin) ?? "", normalizeIsin(autoFilled?.isin)),
  };
}
